export default __webpack_public_path__ + "assets/images/image-puzzle.b9031f19.png";